import { useContext } from "react";
import { OrgContext, OrgState } from "../../providers";

export function useOrgCtx(): OrgState {
  const orgCtx = useContext(OrgContext);

  if (!orgCtx) {
    throw new Error("useOrg must be used within a OrgProvider");
  }

  return orgCtx;
}
